import { FileAttachment } from 'components/common/AttachmentPreview';
// Cambia este import para que use TU interfaz, no la del archivo de datos estáticos
import { Message, Conversation } from 'data/chat'; 
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ChatState } from 'providers/ChatProvider';
dayjs.extend(relativeTime);

export const SET_CHAT_STATE = 'SET_CHAT_STATE';
export const SENT_MESSAGE = 'SENT_MESSAGE';
export const SET_CURRENT_CONVERSATION = 'SET_CURRENT_CONVERSATION';
export const FILTER_CONVERSION_LIST = 'FILTER_CONVERSION_LIST';
export const MARKED_AS_READ = 'MARKED_AS_READ';
export const RESET = 'RESET';
export const NEW_INBOUND_MESSAGE = 'NEW_INBOUND_MESSAGE';

export type ACTIONTYPE =
  | { type: typeof SET_CHAT_STATE; payload: Partial<ChatState> }
  | {
      type: typeof SENT_MESSAGE;
      payload: {
        conversationId: string | number; // Cambiado a string | number
        message?: string;
        attachments?: { images?: string[]; file?: FileAttachment };
      };
    }
  | {
      type: typeof SET_CURRENT_CONVERSATION;
      payload: { conversationId?: number | string };
    }
  | { type: typeof FILTER_CONVERSION_LIST; payload: 'read' | 'unread' | 'all' }
  | { type: typeof MARKED_AS_READ; payload: { conversationId: string | number } } // Cambiado
  | { type: typeof RESET }
  | { type: typeof NEW_INBOUND_MESSAGE; payload: { conversationId: string | number; message: Message; newConversation?: Conversation;  } };

export const chatReducer = (state: ChatState, action: ACTIONTYPE) => {
  switch (action.type) {
    case SET_CHAT_STATE: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    
    case SENT_MESSAGE: {
  const { payload } = action;
  
  // 1. Buscamos la conversación que queremos actualizar
  const targetConversation = state.conversations.find(
    c => c.id === payload.conversationId
  );

  if (!targetConversation) return state;

  // 2. Creamos la conversación actualizada con el nuevo mensaje
  const updatedConversation = {
    ...targetConversation,
    messages: [
      ...targetConversation.messages,
      {
        id: Date.now(), // ID temporal
        type: 'sent',
        time: dayjs().format('h:mm A'),
        readAt: null,
        message: payload.message,
        attachments: payload.attachments,
        seen: false // Importante para la lógica de ticks
      } as Message
    ]
  };

  // 3. Filtramos la lista original para sacar la versión vieja y 
  // ponemos la actualizada al principio (índice 0)
  const otherConversations = state.conversations.filter(
    c => c.id !== payload.conversationId
  );

  return {
    ...state,
    conversations: [updatedConversation, ...otherConversations]
  };
  }

case SET_CURRENT_CONVERSATION: {
  const { payload } = action;
  
  // Ahora comparamos el ID de la conversación (compuesto)
  // con el conversationId que viene en el payload
  const conversation = state.conversations.find(
    conv => String(conv.id) === String(payload.conversationId)
  );

  return {
    ...state,
    currentConversation: conversation || null
  };
}


  case FILTER_CONVERSION_LIST: {
    const { payload } = action;
    // Ojo: el filter original del template eliminaba de la lista las que no coincidían. 
    // Si quieres que el filtro funcione sobre la lista completa, el backend debería manejarlo 
    // o necesitarías un estado de "conversaciones filtradas". Por ahora lo dejamos igual.
    const conversations = state.conversations.filter(conversation => {
      const hasUnreadMeassages = conversation.messages.some(
        message => !message.readAt
      );
      return payload === 'read'
        ? !hasUnreadMeassages
        : payload === 'unread'
        ? hasUnreadMeassages
        : true;
    });
    return {
      ...state,
      conversations
    };
  }

  case MARKED_AS_READ: {
    const { payload } = action;
    const conversations = state.conversations.map(conversation => {
      if (conversation.id === payload.conversationId) {
        return {
          ...conversation,
          messages: conversation.messages.map(message => ({
            ...message,
            readAt: new Date()
          }))
        };
      } else {
        return conversation;
      }
    });
    return {
      ...state,
      conversations: conversations
    };
  }


case NEW_INBOUND_MESSAGE: { // Cambiado de 'string' a la constante NEW_INBOUND_MESSAGE
      const { conversationId, message, newConversation } = action.payload;

      const conversationIndex = state.conversations.findIndex(c => c.id === conversationId);

      if (conversationIndex !== -1) {
        // Chat conocido: Actualizar mensajes y mover al principio
        const targetConv = state.conversations[conversationIndex];
        
        const updatedConversation = {
          ...targetConv,
          messages: [...targetConv.messages, message]
        };

        const otherConversations = state.conversations.filter(c => c.id !== conversationId);

        return {
          ...state,
          conversations: [updatedConversation, ...otherConversations]
        };
      } else if (newConversation) {
        // Chat nuevo: Inyectar conversación completa arriba de todo
        return {
          ...state,
          conversations: [newConversation, ...state.conversations]
        };
      }

      return state;
    }

    case RESET:
      return {
        ...state
      };
    default:
      return state;
  }
};